import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [config, setConfig] = useState({ contact_unlock_price: 50, launch_bonus_percent: 20, wallet_packages: [50, 100, 150, 250, 500], currency: "TL" });
  const [impersonating, setImpersonating] = useState(!!localStorage.getItem("ustayla_admin_token"));

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return null;
    }
  }, []);

  const startImpersonation = (token, targetUser) => {
    const adminToken = localStorage.getItem("ustayla_token");
    if (adminToken) localStorage.setItem("ustayla_admin_token", adminToken);
    setToken(token);
    setImpersonating(true);
    setUser(targetUser);
  };

  const stopImpersonation = () => {
    const adminToken = localStorage.getItem("ustayla_admin_token");
    localStorage.removeItem("ustayla_admin_token");
    if (adminToken) setToken(adminToken);
    setImpersonating(false);
    refreshUser();
  };

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      // OAuth callback in progress — AuthCallback establishes the session; don't force anon here.
      return;
    }
    refreshUser();
    api.get("/config").then(({ data }) => setConfig(data)).catch(() => {});
  }, [refreshUser]);

  const loginSuccess = (data) => {
    if (data.token) setToken(data.token);
    setUser(data.user);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, config, refreshUser, loginSuccess, logout, impersonating, readOnly: impersonating, startImpersonation, stopImpersonation }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
